"use strict";

import Dom from "common/Dom";
var activeLink = null;
export const activeAnchorLinks = function activeAnchorLinks() {
  var scrollPosition = $(document).scrollTop();
  $(Dom.anchorLink).each(function () {
    var currentLink = $(this);
    var refElement = $(currentLink.attr("href") + "-section");
    if (
      !activeLink ||
      (scrollPosition > refElement.position().top &&
        scrollPosition < refElement.position().top + refElement.outerHeight())
    ) {
      activeLink = currentLink;
    }
  });
  $(Dom.anchorLink).removeClass("is-active");
  activeLink.addClass("is-active");
};
export const scrollToLink = function scrollToLink($this) {
  var headerHeight = $(Dom.header).outerHeight();
  var anchor = $this.attr("href") + "-section";
  $("html,body").animate(
    {
      scrollTop: $(anchor).offset().top - headerHeight,
    },
    "slow",
  );
};
